// extracted by mini-css-extract-plugin
export default {"finishApp":"FinishApplicationPage_finishApp__S8MCR","main":"FinishApplicationPage_main__W5Dbx"};